"use client"

import { cn } from "@/lib/utils"
import { validatePassword } from "@/lib/helpers/password-validation"
import { useEffect, useState } from "react"
import { CheckCircleSolid, XCircle } from "@medusajs/icons"

export const PasswordValidator = ({
  password,
  setError,
}: {
  password: string
  setError: (error: any) => void
}) => {
  const [newPasswordError, setNewPasswordError] = useState({
    isValid: false,
    lower: false,
    upper: false,
    "8chars": false,
    symbolOrDigit: false,
  })

  useEffect(() => {
    const validation = validatePassword(password)

    setError({
      isValid: validation.isValid,
      lower: validation.errors.noLower,
      upper: validation.errors.noUpper,
      "8chars": validation.errors.tooShort,
      symbolOrDigit: validation.errors.noDigitOrSymbol,
    })
    setNewPasswordError({
      isValid: validation.isValid,
      lower: validation.errors.noLower,
      upper: validation.errors.noUpper,
      "8chars": validation.errors.tooShort,
      symbolOrDigit: validation.errors.noDigitOrSymbol,
    })
  }, [password])
  return (
    <div className="pb-[28px] pt-[16px]">
      <div
        className={cn(
          "flex items-center gap-[8px]",
          newPasswordError["8chars"] ? "text-[#ff6467]" : "text-green-600"
        )}
      >
        {newPasswordError["8chars"] ? (
          <XCircle className="w-[16px] h-[16px]" />
        ) : (
          <CheckCircleSolid className="w-[16px] h-[16px]" />
        )}
        <p className="text-[14px] leading-[20px]">At least 8 characters</p>
      </div>
      <div
        className={cn(
          "flex items-center gap-[8px] pt-[6px]",
          newPasswordError["lower"] ? "text-[#ff6467]" : "text-green-600"
        )}
      >
        {newPasswordError["lower"] ? (
          <XCircle className="w-[16px] h-[16px]" />
        ) : (
          <CheckCircleSolid className="w-[16px] h-[16px]" />
        )}
        <p className="text-[14px] leading-[20px]">One lowercase letter</p>
      </div>
      <div
        className={cn(
          "flex items-center gap-[8px] pt-[6px]",
          newPasswordError["upper"] ? "text-[#ff6467]" : "text-green-600"
        )}
      >
        {newPasswordError["upper"] ? (
          <XCircle className="w-[16px] h-[16px]" />
        ) : (
          <CheckCircleSolid className="w-[16px] h-[16px]" />
        )}
        <p className="text-[14px] leading-[20px]">One uppercase letter</p>
      </div>
      <div
        className={cn(
          "flex items-center gap-[8px] pt-[6px]",
          newPasswordError["symbolOrDigit"] ? "text-[#ff6467]" : "text-green-600"
        )}
      >
        {newPasswordError["symbolOrDigit"] ? (
          <XCircle className="w-[16px] h-[16px]" />
        ) : (
          <CheckCircleSolid className="w-[16px] h-[16px]" />
        )}
        <p className="text-[14px] leading-[20px]">One number or symbol</p>
      </div>
    </div>
  )
}
